import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-ink-line bg-ink px-4 pb-32 pt-10 sm:px-6" data-id="element-123" data-mp="207t2iadmpnm3">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-124" data-mp="2f4tm1qlo2c9h">
        <div className="flex items-center justify-center gap-2" data-id="element-125" data-mp="2f4bh85kxuppy">
          <ShieldCheckIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-126" data-mp="2a5h0d96j7b8h" />
          <span className="text-[12px] font-bold uppercase tracking-[0.2em] text-cream/80" data-id="element-127" data-mp="1mg5y1n9j98s8">
            Protocollo Clinico Sicuro™
          </span>
        </div>
        <p className="mt-4 text-[12px] leading-relaxed text-cream/40" data-id="element-128" data-mp="1hiw9e9tyx15g">
          © {new Date().getFullYear()} · Dott.ssa Karito – Protocollo Clinico
          Sicuro™. Tutti i diritti riservati.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-[11.5px] leading-relaxed text-cream/30" data-id="element-129" data-mp="1rdxv0vp1bl3a">
          Questo materiale ha finalità esclusivamente educative e non
          sostituisce la formazione professionale, il giudizio clinico
          individuale o le linee guida applicabili. Ogni decisione terapeutica
          deve essere valutata dal professionista in base alle caratteristiche
          specifiche del paziente.
        </p>
      </div>
    </footer>;
}